// VEPC Gestao - Central Administrativa: Utilitários Web e Sanitização Contextual XSS
export function escapeHtml(str) {
  if (str === null || str === undefined) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function formatarMoeda(centavos) {
  if (centavos === null || centavos === undefined) return '—';
  return `R$ ${(centavos / 100).toFixed(2).replace('.', ',')}`;
}
